import { getCurrentMode } from 'utils/storages';

export const getAuthHost = () => {
  const currentEnv = getCurrentMode();
  if (currentEnv === 'test') {
    return import.meta.env.VITE_DEVELOP_AUTH_URL;
  }
  if (currentEnv === 'stage') {
    return import.meta.env.VITE_DEVELOP_AUTH_URL;
  }
  return import.meta.env.VITE_PRODUCTION_AUTH_URL;
};

export const getStoreHost = () => {
  const currentEnv = getCurrentMode();
  if (currentEnv === 'test') {
    return import.meta.env.VITE_DEVELOP_STORE_URL;
  }
  if (currentEnv === 'stage') {
    return import.meta.env.VITE_DEVELOP_STORE_URL;
  }
  return import.meta.env.VITE_PRODUCTION_STORE_URL;
};
